import { statusRecipe } from '../constants/recipe-status.constant';

export const hideApproveButton = (status) => {
	if (status === statusRecipe.approve) {
		return { display: 'none' };
	}
	return null;
};
